import type { FC } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import Button from '@/shared/components/flip-ui-kit/Button';
import ChatIcon from '@/shared/icons/flip-ui-kit/large/Chat';
import DotsHorizontalIcon from '@/shared/icons/flip-ui-kit/large/DotsHorizontal';
import HelpIcon from '@/shared/icons/flip-ui-kit/large/Help';

export const standardItems = [
  {
    label: 'Help & Support',
    Icon: HelpIcon,
    href: 'https://discord.com/channels/824147014140952596/1463102341032050748',
  },
  {
    label: 'Leave feedback',
    Icon: ChatIcon,
    href: 'https://discord.com/channels/824147014140952596/1140570867496132649',
  },
];

const ThreeDotsMenu = ({
  items,
}: {
  items: { label: string; Icon: FC; href: string }[];
}): React.JSX.Element => (
  <DropdownMenu.Root>
    <DropdownMenu.Trigger asChild>
      <Button type="secondary-standard" className="!min-w-0 !p-0">
        <DotsHorizontalIcon className="h-[38px] w-[38px]" />
      </Button>
    </DropdownMenu.Trigger>

    <DropdownMenu.Portal>
      <DropdownMenu.Content
        className="z-20 space-y-2 rounded-md border border-cf-gray-4 bg-cf-gray-3 p-2.5 text-14 text-cf-light-3"
        sideOffset={10}
        align="end"
      >
        {items.map(({ label, Icon, href }) => (
          <DropdownMenu.Item
            key={label}
            className="whitespace-nowrap rounded-md p-1 outline-none transition hover:bg-cf-gray-4 hover:text-white"
          >
            <a href={href} target="_blank" className="flex items-center gap-x-2" rel="noreferrer">
              <Icon />
              {label}
            </a>
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  </DropdownMenu.Root>
);

export default ThreeDotsMenu;
